/**
 * Client-side JWT payload helpers (no signature verification).
 * Used for Cognito id_token claims (email, name) in callback and bootstrap flows.
 */

/**
 * Decode a JWT payload without verifying signature (client-side only).
 * Handles unpadded base64url by re-adding '=' padding before atob.
 */
export function decodeJwtPayload(jwt: string): Record<string, unknown> {
  try {
    const segment = jwt.split(".")[1];
    if (!segment) return {};
    const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "="
    );
    return JSON.parse(atob(padded));
  } catch {
    return {};
  }
}

/** Prefer `name`, else given + family (needs `profile` scope + attributes in Cognito). */
export function displayNameFromClaims(claims: Record<string, unknown>): string {
  const name = (claims.name as string)?.trim();
  if (name) return name;
  const given = (claims.given_name as string)?.trim() ?? "";
  const family = (claims.family_name as string)?.trim() ?? "";
  if (given || family) return [given, family].filter(Boolean).join(" ");
  return "";
}
